define('paramsConfig',["urlHelper", "searchTypeHelper"], function (urlHelper, searchTypeHelper) {
    var paramsConfigForTabs = {
        BoylResults: {
            SrpType: "BoylResults",
            Custom: true,
            CustomResults: true,
            SingleFamily: false
        },
        BuilderResults: {
            SrpType: "BuilderResults",
            CommName: null,
            SingleFamily: false,
            BrandId: 0
        },
        CommunityResults: {
            SrpType: "CommunityResults",
            Mfr: false
        },
        CondoDevelopments: {
            SrpType: "CondoDevelopments",
            SingleFamily: false
        },
        CondoTownHomes: {
            SrpType: "CondoTownHomes",
            SingleFamily: false
        },
        CustomBuilders: {
            SrpType: "CustomBuilders",
            BrandId: 0,
            Brands: []
        },
        CustomHomes: {
            ExcludeBasicListings: true,
            SrpType: "CustomHomes"
        },
        CustomCommunities: {
            ExcludeBasicListings: true,
            SrpType: "CustomCommunities"
        },
        HomeResults: {
            SrpType: "HomeResults"
        },
        ManufacturedHomes: {
            SrpType: "ManufacturedHomes"
        },
        ManufacturedResults: {
            SrpType: "ManufacturedResults"
        }
    };

    var paramsConfigForSortBy = {
        bedroomsHighLow: {
            SortBy: "Bed"
        },
        bedroomsLowHigh: {
            SortBy: "Bed",
            SortOrder: false
        },
        builderAToZ: {
            SortBy: "Brand",
            SortOrder: false
        },
        builderZToA: {
            SortBy: "Brand"
        },
        cityAToZ: {
            SortBy: "City",
            SortOrder: false
        },
        cityZToA: {
            SortBy: "City"
        },
        communityAToZ: {
            SortBy: "Comm",
            SortOrder: false
        },
        communityZToA: {
            SortBy: "Comm"
        },
        default: {
            SortBy: "Random",
            SortOrder: false
        },
        matchingHomes: {
            SortBy: "NumHomes"
        },
        planNameAToZ: {
            SortBy: "Plan",
            SortOrder: false
        },
        planNameZToA: {
            SortBy: "Plan"
        },
        priceLowHigh: {
            SortBy: "Price",
            SortOrder: false
        },
        priceHighLow: {
            SortBy: "Price"
        }
    }

    function getConfigurationForSortBy(order) {
        var defaultParams = {
            PageNumber: 1,
            SortOrder: true
        };

        return Object.assign(defaultParams, paramsConfigForSortBy[order]);
    }

    function getConfigurationForTab(tab) {
        var defaultParams = {
            ExcludeBasicListings: false,
            PageNumber: 1
        };

        return Object.assign(defaultParams, paramsConfigForTabs[tab]);
    }

    function getConfigurationFromAnchor(element) {
        let parameter = element.dataset.parameter;
        const url = element.href;

        if (!parameter || !url) {
            return { };
        }

        const searchResultFunction = searchTypeHelper.getSrpFunction(url);
        const searchResultType = searchTypeHelper.getSrpType(searchResultFunction);
        const searchResultParameters = getConfigurationForTab(searchResultType);
        let value = urlHelper.getValueFromQueryString(parameter, url) || urlHelper.getValueFromUrlSegment(parameter, url);
        const alias = element.dataset.alias;

        if (!value) {
            return {};
        }

        if (Array.isArray(searchResultParameters[parameter])) {
            value = [value];
        }

        parameter = alias || parameter;
        searchResultParameters[parameter] = value;
        return searchResultParameters;
    }

    return {
        getSortByParameters: getConfigurationForSortBy,
        getTabParameters: getConfigurationForTab,
        getConfigurationFromAnchor: getConfigurationFromAnchor
    }
});
